<script lang="ts">
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";

  let {
    phone,
    back = false,
  }: {
    phone: string;
    back: boolean;
  } = $props();
</script>

<h2 class="ui-title">We can't verify this account online</h2>

<p>
  We weren't able to verify your bank account after several attempts. To make sure your settlement reaches you safely,
  please give us a call at <a class="underline text-blue-500" href="tel:{phone}">{phone}</a> and we'll work through
  this with you.
</p>

<div class="pt-40"></div>
<FooterButtons {back}>
  {#if !back}<CloseButton />{/if}
  <a class="btn btn-primary" href="tel:{phone}">Call us</a>
</FooterButtons>
